import { Injectable } from '@angular/core';

import { CanvasElementId } from '@blaze-runtime/engine-domain';

@Injectable({ providedIn: 'root' })
export class PdfViewerService {
  pdfViewers: Set<CanvasElementId> = new Set();

  addInstance(elementId: CanvasElementId): void {
    this.pdfViewers.add(elementId);
  }

  deleteInstance(elementId: CanvasElementId): void {
    this.pdfViewers.delete(elementId);
  }
}
